<template>
    <div id="peek">
        <div class="loader" v-if="isloading"></div>
        <div id="email__message" v-else>
            <div v-html="message"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Peek',
    mounted() {
        var view = this
        let id = this.$route.params.muid
        view.$store.dispatch('Email/setIsLoading', true)
        view.$utils.fetchEmail(view, id)
    },
    computed: {
        isloading: function() {
            return this.$store.getters['Email/getIsLoading']
        },
        message: function() {
            return this.$store.getters['Email/getEmailBody']
        }
    }
}
</script>